import { ChangeDetectorRef, Component, OnInit, AfterViewInit, ElementRef, NgZone, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { SafePipe } from '../../pipes/safe.pipe';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ContentContainerComponent } from '../../../shared-ui/content-container/content-container.component';

@Component({
  selector: 'app-investment-tutorials',
  templateUrl: './investment-tutorials.component.html',
  styleUrls: ['../../shared/styles/view-shell.css', './investment-tutorials.component.css'],
  standalone: true,
  imports: [CommonModule, SafePipe, ContentContainerComponent]
})
export class InvestmentTutorialsComponent implements OnInit, AfterViewInit {

  // Dropdown de sección Ayuda en móvil
  mobileMenuOpen = false;
  readonly activeTabLabel = 'Tutorial de inversión';

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  tutorialVideos = [
    {
      id: 'ZWjGr4q9i28',
      title: '¿Cómo funciona el programa Domoblock?',
      description: 'Aprende los fundamentos del programa de inversión de Domoblock'
    },
    {
      id: 'ykr8H2_87bo',
      title: 'Tres preguntas típicas sobre inversión',
      description: 'Resolvemos las dudas más comunes sobre inversión inmobiliaria'
    },
    {
      id: 'gN8AK0s3rwA',
      title: 'GANA DINERO con el programa Domoblock',
      description: 'Descubre cómo generar ingresos con nuestra plataforma'
    },
    {
      id: 'mT3bfpVLgng',
      title: 'Consulta el retorno de tu inversión',
      description: 'Aprende cómo verificar y calcular el retorno de tus inversiones'
    },
    {
      id: '9FeqluQSZrQ',
      title: 'Ventajas de la inversión inmobiliaria tokenizada',
      description: 'Por qué la tokenización está revolucionando el sector inmobiliario'
    },
    {
      id: 'hyxKBv4ltoU',
      title: 'Guía paso a paso para tu primera inversión',
      description: 'Tutorial completo para nuevos inversores'
    },
    {
      id: 'wI9ZTq9_yzw',
      title: 'Análisis de rentabilidad en proyectos inmobiliarios',
      description: 'Cómo evaluar el potencial de retorno de una inversión'
    },
    {
      id: 'gm6BAUkWVBk',
      title: 'Seguridad y transparencia en Domoblock',
      description: 'Conoce nuestros sistemas de protección al inversor'
    },
    {
      id: 'h2DkKhOYpOI',
      title: 'Diversificación de cartera inmobiliaria',
      description: 'Estrategias para reducir riesgos y maximizar retornos'
    },
    {
      id: 'a993TXOxMJ0',
      title: 'Proyectos de éxito en Domoblock',
      description: 'Casos de estudio de inversiones con altos rendimientos'
    },
    {
      id: 'HxMEUp0q2eg',
      title: 'Reclamo de dividendos',
      description: 'Aprende cómo reclamar y gestionar tus dividendos de inversión'
    }
  ];

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private afs: AngularFirestore,
    private router: Router,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Aplicar fondo blanco a todos los elementos relevantes
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';
    this.applyWhiteBackground();
    
    // Cargar tutoriales desde Firebase
    this.loadTutorialsFromFirebase();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.applyWhiteBackground();
    }, 100);
  }

  navigateFaqs(){
    this.router.navigate(['/faqs']);
  }

  navigateContact(){
    this.router.navigate(['/contacto']);
  }

  private applyWhiteBackground(): void {
    document.body.style.backgroundColor = '#ffffff';
  }

  loadTutorialsFromFirebase() {
    this.afs.collection('tutorials').doc('investment-tutorials').valueChanges().subscribe({
      next: (data: any) => {
        // Firebase puede emitir fuera de la zona de Angular → forzamos CD.
        this.ngZone.run(() => {
          if (data && data.tutorials) {
            this.tutorialVideos = data.tutorials;
          }
          // Si no hay datos en Firebase, se mantienen los tutoriales por defecto
          this.cdr.detectChanges();
        });
      },
      error: (error) => {
        console.error('Error loading tutorials from Firebase:', error);
        // En caso de error, se mantienen los tutoriales por defecto
        this.ngZone.run(() => {
          this.cdr.detectChanges();
        });
      }
    });
  }
}
